import { apiSlice } from '../../app/api/apiSlice'
import toast from 'react-hot-toast'
import { urlConfig } from '../../config'
import { CloseAccount } from '../../components/Dashboard/account-page/CloseAccount'

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    login: builder.mutation({
      query: credentials => ({
        url: `${urlConfig.authBaseUrl}/auth/login`,
        method: 'POST',
        body: { ...credentials },
      }),

      transformErrorResponse: (response: any) => {
        // Preserve original status and normalize message to a string
        const status = response?.status ?? response?.data?.statusCode ?? response?.data?.status
        const rawMessage = response?.data?.message ?? response?.error
        const message = Array.isArray(rawMessage)
          ? rawMessage.join('\n')
          : (typeof rawMessage === 'string' ? rawMessage : 'Request failed')
        return {
          status,
          statusCode: status,
          message,
          data: response?.data ?? null,
          rawMessage: rawMessage ?? null,
        }
      },
      onQueryStarted: () => {
        toast.loading('Logging in...')
      },
      transformResponse: res => {
        toast.dismiss()
        toast.success('Login Successful')
        return res
      },
    }),
    logout: builder.mutation<any, void>({
      query: credentials => ({
        url: `${urlConfig.authBaseUrl}/auth/sessions/logout`,
        method: 'POST',
      }),

      transformErrorResponse: (error: any) => {
        return error.data
      },
      onQueryStarted: () => {
        toast.loading('logged out ...')
      },
      transformResponse: res => {
        toast.dismiss()
        toast.success('Logout Successful')
        return res
      },
    }),
    register: builder.mutation({
      query: credentials => ({
        url: `${urlConfig.authBaseUrl}/auth/users/register`,
        method: 'POST',
        body: { ...credentials },
      }),

      transformErrorResponse: (error: any) => {
        return error.data
      },
      onQueryStarted: () => {
        toast.loading('Creating new user...')
      },
      transformResponse: res => {
        toast.dismiss()
        toast.success('Account created successfully', { duration: 2000 })
        return res
      },
    }),

    CloseAccount: builder.mutation<any, void>({
      query: () => ({
        url: `${urlConfig.authBaseUrl}/auth/users/close`,
        method: 'DELETE',
      }),

      transformErrorResponse: (error: any) => {
        return error.data
      },
      onQueryStarted: () => {
        toast.loading('Closing Account...')
      },
      transformResponse: res => {
        toast.dismiss()
        toast.success('Account closed successfully', { duration: 2000 })
        return res
      },
    }),
    subscribeEmail: builder.mutation<any, void>({
      query: () => ({
        url: `${urlConfig.authBaseUrl}/auth/email-subscription/subscribe`,
        method: 'POST',
      }),
      transformErrorResponse: (error: any) => {
        return error.data
      },
    }),
    unsubscribeEmail: builder.mutation<any, { email: string }>({
      query: ({ email }) => ({
        url: `${urlConfig.authBaseUrl}/auth/email-subscription/unsubscribe`,
        method: 'POST',
        body: { email },
      }),
      transformErrorResponse: (error: any) => {
        return error.data
      },
    }),
    getEmailSubscriptionStatus: builder.query<
      {
        email: string
        isSubscribed: boolean
        latestSubscription?: {
          _id: string
          user_email: string
          consent: boolean
          timestamp: string
          ipAddress: string
          source: string
          createdAt: string
          updatedAt: string
        }
      },
      void
    >({
      query: () => ({
        url: `${urlConfig.authBaseUrl}/auth/email-subscription/status`,
        method: 'GET',
      }),
      transformErrorResponse: (error: any) => {
        return error.data
      },
    }),
  }),
})

export const {
  useLoginMutation,
  useRegisterMutation,
  useLogoutMutation,
  useCloseAccountMutation,
  useSubscribeEmailMutation,
  useUnsubscribeEmailMutation,
  useGetEmailSubscriptionStatusQuery,
} = authApiSlice
